module.exports = __webpack_public_path__ + "static/media/bundesagentur-fuer-arbeit.423643e3.jpg";